import 'jquery';
import { Colors } from '@sop/unify-color';

export class Highcharts {
    constructor(brandedColors, colorScheme) {
        this.colors = new Colors(brandedColors, colorScheme);
    }

    createOptions(userOverrides) {
        userOverrides = userOverrides || {};

        const optionsBase = {
            chart: {
                style: {
                    fontFamily: "Whitney Book,Whitney SSM A,Whitney SSm B,Open Sans,Lato,Arial"
                }
            }
        };

        return $.extend(true, optionsBase, userOverrides);
    }

    createStockChart(userOverrides) {
        userOverrides = userOverrides || {};

        var bootstrapSmMax = 767;

        var fontSize = "14px";

        // For some reason Highstocks adds some extra width and height to the size you specify. 
        // Therefore these values are added to the totals, so they can be used in other calculations.
        var rangeSelectorButtonWidthExtra = 4;
        var rangeSelectorButtonHeightExtra = 4;

        /* Vanilla */
        var rangeSelectorButtonSpacing = 50;
        var rangeSelectorButtonWidth = 70;
        var rangeSelectorButtonHeight = 25;

        var rangeSelectorButtonTotalWidth = rangeSelectorButtonWidth + rangeSelectorButtonWidthExtra;
        var rangeSelectorButtonTotalHeight = rangeSelectorButtonHeight + rangeSelectorButtonHeightExtra;

        /* Responsive */
        var responsiveMaxWidth = bootstrapSmMax;

        var rangeSelectorResponsiveButtonSpacing = 25;
        var rangeSelectorResponsiveButtonWidth = 40;
        var rangeSelectorResponsiveButtonHeight = 25;
        var rangeSelectorResponsiveButtonTotalWidth = rangeSelectorResponsiveButtonWidth + rangeSelectorButtonWidthExtra;
        var rangeSelectorResponsiveButtonTotalHeight = rangeSelectorResponsiveButtonHeight + rangeSelectorButtonHeightExtra;

        var scrollbarHeightPx = 22;

        var colorDarkness = "black";
        var colorDarknessLighter = "#3f3f3f";
        var colorDarknessFaded = "#999";
        var colorPrimary = this.colors.primary.hex;

        // primary color with opacity and darkened 5%
        var colorTransparentHighlight = "rgba(0, 148, 211, 0.15)";
        var colorBackgroundHighlight = "#f3f3f3";

        var stockChartBase =
        {
            colors: this.colors.getHarmonious(3).toHexArray(),

            credits: {
                enabled: false
            },

            exporting: {
                enabled: false
            },

            legend: {
                enabled: true,
                align: "left",
                padding: 0,
                margin: scrollbarHeightPx,
                //itemStyle: {
                //    fontSize: fontSize,
                //    fontWeight: "normal",
                //},
                useHTML: true,
                labelFormat: "<div class='unify-highcharts-legend-label'>{name}</div>"
            },

            navigator: {
                outlineColor: "black",
                outlineWidth: 0,
                margin: 18,
                height: 40,
                maskFill: colorTransparentHighlight,
                series: {
                    type: "line",
                    color: colorPrimary,
                    lineWidth: 1
                },
                xAxis: {
                    tickWidth: 0,
                    lineWidth: 0,
                    gridLineWidth: 0,
                    labels: {
                        align: "center",
                        style: {
                            color: colorDarkness,
                            fontSize: fontSize,
                            fontWeight: "bold"
                        },
                        x: 0,
                        y: -10
                    }
                }
            },

            noData: {
                style: {
                    /* Like <H4> */
                    fontSize: "24px",
                    fontWeight: 800
                }
            },

            rangeSelector: {
                allButtonsEnabled: false,
                buttonPosition: {
                    x: rangeSelectorButtonSpacing / 2,
                    y: rangeSelectorButtonHeight - (rangeSelectorButtonHeight / 2)
                },
                buttonSpacing: rangeSelectorButtonSpacing,
                buttonTheme: {
                    width: rangeSelectorButtonWidth,
                    height: rangeSelectorButtonHeight,
                    fill: "none",
                    stroke: "none",
                    "stroke-width": 0,
                    r: 0,
                    style: {
                        color: colorDarknessFaded,
                        fontWeight: "bold",
                        fontSize: fontSize
                    },
                    states: {
                        hover: {
                            fill: "none",
                            stroke: colorPrimary,
                            "stroke-width": 4,
                            style: {
                                "stroke-dasharray": this._getUnderlineStrokeDasharray(rangeSelectorButtonTotalWidth, rangeSelectorButtonTotalHeight)
                            }
                        },
                        select: {
                            fill: "none",
                            stroke: colorPrimary,
                            "stroke-width": 4,
                            style: {
                                color: "black",
                                "stroke-dasharray": this._getUnderlineStrokeDasharray(rangeSelectorButtonTotalWidth, rangeSelectorButtonTotalHeight)
                            }
                        }
                    }
                },
                buttons: [
                    {
                        type: "month",
                        count: 1,
                        text: "1 månad"
                    }, {
                        type: "month",
                        count: 3,
                        text: "3 månad"
                    }, {
                        type: "year",
                        count: 1,
                        text: "1 år"
                    }, {
                        type: "year",
                        count: 3,
                        text: "3 år"
                    }
                ],
                inputEnabled: false,
                labelStyle: {
                    display: "none"
                },
                selected: 0
            },

            responsive: {
                rules: [
                    {
                        condition: {
                            maxWidth: responsiveMaxWidth
                        },
                        chartOptions: {

                            rangeSelector: {
                                buttonPosition: {
                                    x: rangeSelectorResponsiveButtonSpacing / 2,
                                    y: rangeSelectorResponsiveButtonHeight - (rangeSelectorResponsiveButtonHeight / 2)
                                },
                                buttonSpacing: rangeSelectorResponsiveButtonSpacing,
                                buttonTheme: {
                                    width: rangeSelectorResponsiveButtonWidth,
                                    height: rangeSelectorResponsiveButtonHeight,
                                    states: {
                                        hover: {
                                            style: {
                                                "stroke-dasharray": this._getUnderlineStrokeDasharray(rangeSelectorResponsiveButtonTotalWidth, rangeSelectorResponsiveButtonTotalHeight)
                                            }
                                        },
                                        select: {
                                            style: {
                                                "stroke-dasharray": this._getUnderlineStrokeDasharray(rangeSelectorResponsiveButtonTotalWidth, rangeSelectorResponsiveButtonTotalHeight)
                                            }
                                        }
                                    }
                                },
                                buttons: [
                                    {
                                        type: "month",
                                        count: 1,
                                        text: "1 månad"
                                    }, {
                                        type: "month",
                                        count: 3,
                                        text: "3 månad"
                                    }, {
                                        type: "year",
                                        count: 1,
                                        text: "1 år"
                                    }, {
                                        type: "year",
                                        count: 3,
                                        text: "3 år"
                                    }
                                ]
                            },
                            legend: {
                                layout: "vertical",
                                align: "center",
                                /* Due to a probable glitch, this positions the legend to the left */
                                x: "glitch align left",
                                padding: 9
                            },

                            noData: {
                                style: {
                                    /* Like <H4> */
                                    fontSize: "18px"
                                }
                            }
                        }
                    }]
            },

            scrollbar: {
                height: scrollbarHeightPx,
                barBackgroundColor: colorPrimary,
                barBorderRadius: 0,
                barBorderWidth: 0,
                buttonBackgroundColor: colorPrimary,
                buttonBorderWidth: 0,
                buttonArrowColor: "white",
                buttonBorderRadius: 0,
                rifleColor: "white",
                trackBackgroundColor: colorBackgroundHighlight,
                trackBorderWidth: 0,
                trackBorderRadius: 0
            },

            tooltip: {
                backgroundColor: "rgba(255,255,255,0.95)",
                borderWidth: 0,
                padding: 17,
                useHTML: true,
                headerFormat:
                    //"<div class="unify-highcharts-tooltip-arrow"></div>" +
                    "<h7 class='unify-highcharts-tooltip-heading'>{point.key}</h7>",
                pointFormat:
                    "<div class='unify-highcharts-tooltip-point'>" +
                    "<div class='unify-highcharts-tooltip-point__bullet' style='background-color: {point.color};'></div>" +
                    "<p>{series.name}</p>" +
                    "<p>{point.y}</p>" +
                    "</div>"
            },

            title: null,

            xAxis: {
                minTickInterval: 10,
                labels: {
                    style: {
                        cursor: "default",
                        fontSize: fontSize,
                        fontWeight: "200",
                        color: colorDarknessLighter
                    }
                },
                tickWidth: 0,
                lineWidth: 2,
                lineColor: colorDarknessFaded,
                offset: 45
            },

            yAxis: {
                labels: {
                    style: {
                        fontSize: fontSize,
                        color: colorDarknessLighter
                    }
                },
                lineWidth: 0,
                gridLineDashStyle: "Dot",
                gridLineColor: colorDarknessFaded
            }
        };

        /* Set unify responsive maxWidth on any user specified responsive rules*/
        if (userOverrides.responsive && userOverrides.responsive.rules && userOverrides.responsive.rules.length) {
            for (var i = 0; i < userOverrides.responsive.rules.length; i++) {

                if (userOverrides.responsive.rules[i].condition &&
                    userOverrides.responsive.rules[i].condition.maxWidth &&
                    userOverrides.responsive.rules[i].condition.maxWidth === "UNIFY_HIGHCHARTS_RESPONSIVE_MAX_WIDTH") {
                    userOverrides.responsive.rules[i].condition.maxWidth = responsiveMaxWidth;
                }
            }
        }

        return $.extend(true, stockChartBase, userOverrides);
    }

    /**
    * Returns a stroke-dasharray configuration that produces an underline on a rectangle with the specified width and height.
    * @param {number} width the width of the dash
    * @param {number} height the height of the dash
    * @returns {string} a underline strok dash array in string format
    */
    _getUnderlineStrokeDasharray(width, height) {
        return "0, " + (width + height) + ", " + width + ", " + height;
    }
}
